import React from "react";
import { FaCalendarAlt, FaUser, FaChurch, FaInfoCircle } from "react-icons/fa";
import dayjs from "dayjs";

const WorshipView = ({ currentRecord }) => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      <h2 className="mb-4 text-2xl font-bold text-gray-800">Worship Details</h2>
      <InfoTable jsonData={currentRecord} />
    </div>
  );
};

export default WorshipView;

const InfoTable = ({ jsonData }) => {
  const keysToShow = Object.keys(jsonData).filter(
    (key) =>
      ![
        "__v",
        "id",
        "createdAt",
        "church_id",
        "createdBy",
        "updatedAt",
        "_id",
      ].includes(key)
  );

  const formatDate = (dateString) => {
    return dayjs(dateString).utc().format("MM/DD/YYYY");
  };

  const getIcon = (key) => {
    if (key.includes("date"))
      return <FaCalendarAlt className="text-blue-500" />;
    if (key.includes("name")) return <FaUser className="text-green-500" />;
    if (key.includes("church")) return <FaChurch className="text-purple-500" />;
    return <FaInfoCircle className="text-gray-500" />;
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse table-auto">
        <tbody>
          {keysToShow.map((key, index) => {
            const isDateField = key.includes("date");
            const value = jsonData[key];
            const displayValue =
              isDateField && typeof value === "string"
                ? formatDate(value)
                : typeof value === "object" && value !== null
                ? value.label
                : value;

            return (
              <tr
                key={key}
                className={`${
                  index % 2 === 0 ? "bg-gray-50" : "bg-white"
                } hover:bg-gray-100 transition-colors duration-200`}
              >
                <td className="flex items-center px-4 py-3 font-medium text-gray-700 border-b border-gray-200">
                  {getIcon(key)}
                  <span className="ml-2">
                    {key
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (l) => l.toUpperCase())}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-800 border-b border-gray-200">
                  {displayValue}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
